var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5225 17.5225 22 12 22C6.4775 22 2 17.5225 2 12C2 6.4775 6.4775 2 12 2C17.5225 2 22 6.4775 22 12Z",
    fill: "url(#paint0_linear_116_3321)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.596 14.475L14.1215 12L16.5965 9.52497C16.987 9.13447 16.987 8.50147 16.5965 8.11097L15.8895 7.40397C15.499 7.01347 14.866 7.01347 14.4755 7.40397L12 9.87847L9.525 7.40347C9.1345 7.01297 8.5015 7.01297 8.111 7.40347L7.404 8.11047C7.0135 8.50097 7.0135 9.13397 7.404 9.52447L9.879 11.9995L7.404 14.4745C7.0135 14.865 7.0135 15.498 7.404 15.8885L8.111 16.5955C8.5015 16.986 9.1345 16.986 9.525 16.5955L12 14.1205L14.475 16.5955C14.8655 16.986 15.4985 16.986 15.889 16.5955L16.596 15.8885C16.9865 15.4985 16.9865 14.8655 16.596 14.475Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M16.4195 14.6515L13.768 12L16.4195 9.34853C16.7125 9.05553 16.7125 8.58053 16.4195 8.28803L15.7125 7.58103C15.4195 7.28803 14.9445 7.28803 14.652 7.58103L12 10.232L9.3485 7.58053C9.0555 7.28753 8.5805 7.28753 8.288 7.58053L7.581 8.28753C7.288 8.58053 7.288 9.05553 7.581 9.34803L10.232 12L7.5805 14.6515C7.2875 14.9445 7.2875 15.4195 7.5805 15.712L8.2875 16.419C8.5805 16.712 9.0555 16.712 9.348 16.419L12 13.768L14.6515 16.4195C14.9445 16.7125 15.4195 16.7125 15.712 16.4195L16.419 15.7125C16.7125 15.4195 16.7125 14.9445 16.4195 14.6515Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5355 7.75753L16.2425 8.46453C16.438 8.66003 16.438 8.97653 16.2425 9.17153L9.1715 16.2425C8.976 16.438 8.6595 16.438 8.4645 16.2425L7.7575 15.5355C7.562 15.34 7.562 15.0235 7.7575 14.8285L14.8285 7.75753C15.0235 7.56203 15.3405 7.56203 15.5355 7.75753Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2425 15.5355L15.5355 16.2425C15.34 16.438 15.0235 16.438 14.8285 16.2425L7.7575 9.17153C7.562 8.97603 7.562 8.65953 7.7575 8.46453L8.4645 7.75753C8.66 7.56203 8.9765 7.56203 9.1715 7.75753L16.2425 14.8285C16.438 15.0235 16.438 15.3405 16.2425 15.5355Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_3321",
    x1: 4.929,
    y1: 4.929,
    x2: 19.071,
    y2: 19.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.46c6f79ec62fd09156e9f4e085367413.svg";
export { ForwardRef as ReactComponent };